import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Button } from '@orbita-ui/core';
import { useNavigate, useParams } from 'react-router-dom';
import { useRootLoadingSpinner } from 'shared/spinner';
import { Card } from 'shared/components';
import { useUserService } from 'user/services/useUserService';
import { LOGIN_PATH } from 'user/routes';

export function ConfirmationEmailPage() {
  const navigate = useNavigate();
  let { tokenEmail } = useParams();
  const [errorState, setErrorState] = useState(false);

  const goLoginOrMenuHandler = () => {
    navigate(LOGIN_PATH);
  };
  const { setRootLoadingSpinnerStatus } = useRootLoadingSpinner();
  const userService = useUserService();

  useEffect(() => {
    console.log('[ConfirmationEmailPage] useEffect running with token:', tokenEmail);
    setRootLoadingSpinnerStatus(true);
    const fetchData = async () => {
      try {
        if (tokenEmail) {
          await userService.confirmEmail(tokenEmail);
        } else {
          throw new Error('No token provided');
        }
      } catch (e) {
        setErrorState(true);
      } finally {
        setRootLoadingSpinnerStatus(false);
      }
    };

    fetchData();
  }, [navigate, setRootLoadingSpinnerStatus, tokenEmail, userService]);

  return (
    <Container>
      <Row className="mt-3">
        <Col>
          <Card variant={errorState ? 'error' : 'info'}>
            <Row className="mt-1 mb-3">
              {errorState ? (
                <Col>El enlace no es válido porque expiró o ya fue utilizado</Col>
              ) : (
                <Col>Su dirección de correo electronico se encuentra verificada</Col>
              )}
            </Row>
            <Row>
              <Col className="mb-2 text-end">
                <Button onClick={() => goLoginOrMenuHandler()}>Continuar</Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
